import { BranchPowerMonitorData, useBranchEnergyCalculation } from 'common';
import { useEffect, useState } from 'react';

import { useAppSync } from '../../contexts/AppSyncContext';

export const useGetRawElectricalData = () => {
  const { hub, sensors } = useAppSync();

  const {
    powerMonitorSensor,
    branchPowerMonitorData,
    isValidConfiguration,
    refresh,
    loading: sensorEventsLoading,
  } = useBranchEnergyCalculation({
    selectedHub: hub,
    sensors,
  });

  const [data, setData] = useState<BranchPowerMonitorData[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    // Don't try to fetch data if we don't have a power monitor sensor
    if (!powerMonitorSensor) {
      setData([]);
      setLoading(false);
      setError(null);
      return;
    }

    // Wait for sensor events to finish loading
    if (sensorEventsLoading) {
      setLoading(true);
      return;
    }

    try {
      setLoading(true);
      setError(null);

      // If we have raw readings, use them directly
      if (branchPowerMonitorData && branchPowerMonitorData.length > 0) {
        setData(branchPowerMonitorData);
      } else {
        setData([]);
      }
    } catch (err) {
      console.error('Error fetching electrical raw data:', err);
      setError(
        err instanceof Error ? err : new Error('Unknown error fetching electrical raw data'),
      );
    } finally {
      setLoading(false);
    }
  }, [powerMonitorSensor?.id, sensorEventsLoading, branchPowerMonitorData]);

  return {
    data,
    isValidConfiguration,
    refresh,
    loading,
    error,
  };
};
